import { DISPATCH_STATUS } from "./dispatch-status.enum";
export const Enums = {
  DISPATCH_STATUS: DISPATCH_STATUS
}
